import { Button, Col, Container, Image, Row } from 'react-bootstrap';
import './HomePage.css'
import Ship from '../Ship';

export const HomePage: React.FC = () => {
    return (
        <>
            <Container className="containBack justify-content-center p-0" >
                <Ship />
                
                {/* <Row>
                    <div className="black">
                        <h1 style={{fontSize: '3rem', fontWeight: "bold"}}>“Come for the food stay for the friendship”</h1>
                        <div>
                            <p style={{margin: 0, fontSize: '1.6rem'}}>Casual Dining</p>
                            <p style={{margin: 0, fontSize: '1.6rem'}}>Take out  ~  Eat In  ~  Catering</p>
                            <p style={{margin: 0, fontSize: '1.6rem'}}>True Passion   True Ingredients   True Flavor</p>
                        </div>
                        <div>
                            <h1 style={{fontSize: '2rem'}}>109 Marshall Lane</h1>
                            <h1 style={{fontSize: '2rem'}}>Brodheadsville Pa 18322</h1>
                            <h1 style={{fontSize: '2rem'}}>(570) 994-4134</h1>
                        </div>
                        <p> Behind Truist bank off of rt. 209 in the old Rita’s building.</p>
                    </div>
                </Row> */}
                
                <Row className="white">
                    <Col xs={12} lg={6} className="mb-3 mt-3 frame">
                        <div>
                            <iframe style={{minHeight: "300px"}} width="100%" height="100%" src="https://www.youtube.com/embed/BEUjjUe_umY" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                            <p className="cooperl" style={{fontSize: "1rem"}}>"When I cook, I cook with my heart… with <span style={{fontWeight: "bold"}}>love</span>. I enjoy cooking for and feeding people. It has been my passion for as long as I can remember. Creating large holiday meals with my grandmother and mother was so joyful. The excitement of creating all the traditional family dishes and gathering with family and friends was pure happiness. I wanted to recreate that feeling and share my love with everyone! And so, Sauce was born!"</p>
                            <p className="cooperl" style={{fontSize: "1rem", textAlign: "end", fontWeight: "bold"}}>- Margaret LaFiura (Owner)</p>
                        </div>
                    </Col>
                    <Col xs={12} lg={6} className="white px-0 px-lg-3 mb-4 mt-3">
                        <Image src="./food.jpg" alt="food" width="100%" height="50%" style={{minHeight: "300px", objectFit: "cover"}}/>
                        {/* <div style={{margin: "3rem 3rem 0 3rem", color: "black", height: "4px", backgroundColor: "black"}} /> */}
                        <p className="cooperl px-0 px-lg-2" style={{textAlign: "justify", margin: "1rem", fontSize: "1rem"}}><span style={{fontWeight: "bold"}}>Sauce</span> is a locally and family-owned business. Providing a comfortable laid-back atmosphere Where all our guests are treated like family! 
                            We put an emphasis on good quality comfort food and warm friendly service.
                            We are dedicated to providing our guests with an unforgettably delicious meal at an affordable price.
                        </p>
                    </Col>
                </Row>
                <div className="image-wrapper">
                    <Image className="hero-image" src="pasta.png" alt="pasta"></Image>
                    <div className="hero-text">
                        <Button className="cooperb px-4" style={{backgroundColor: "#ff0000", fontSize: "2rem", borderRadius: "30px"}} variant="danger" onClick={() => window.location.pathname = "/menu"}>View Menu</Button>
                    </div>
                </div>
            </Container>
            <Row className="justify-content-center text-align-center text-white" style={{width: '100%'}}>
                <div className="footer mt-5">
                <h5>
                    109 Marshall Lane
                    Brodheadsville Pa 18322
                    (570) 994-4134
                </h5>
                </div>
            </Row>
        </>
    )
}